export const CACHE_TIMES = {
  users: 10 * 60 * 1000,
  groups: 5 * 60 * 1000,
  groupMembers: 2 * 60 * 1000,
  goals: 2 * 60 * 1000,
  metrics: 30 * 1000,
} as const;
